// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var opusRouter = {
  path: '/opus',
  component: Layout,
  redirect: '/opus/list',
  name: '0pus',
  alwaysShow: true,
  meta: {
    title: '作品',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/opus/list');
    },
    name: 'opus',
    meta: {
      title: '作品列表'
    }
  },
  // {
  //   path: 'apply',
  //   component: () => import('@/views/opus/apply'),
  //   name: 'apply',
  //   meta: { title: '作品审核' },
  // },
  {
    path: 'reply',
    component: function component() {
      return import('@/views/opus/reply/index');
    },
    name: 'replyList',
    meta: {
      title: '评论管理'
    }
  }]
};
export default opusRouter;